// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "container-1HWhW";
var _3 = "flight-1d4hF";
var _4 = "selected-3MAmk";
var _5 = "flight_opened-sTNl4";
var _6 = "flight_dropdown-ce5yn";
var _7 = "flight_readonly-3dT_x";
var _8 = "flightContent-24vnL";
var _9 = "segments-3c7IM";
var _a = "segmentItem-2hGZR";
var _b = "checkinCardItem__container-3jqpL";
var _c = "transferText-1LkqR";
var _d = "totalDurationText--iKBg";
var _e = "segments_withoutPrices-oudIK";
var _f = "segmentSelector_container-3ZRxa";
var _10 = "segmentSelector-3wTGk";
var _11 = "showSelected-3Uawz";
var _12 = "segment_segmentSelector-1R4PK";
var _13 = "segment_segmentSelector_checkbox-gDdQb";
var _14 = "checked-2mtDD";
var _15 = "duration-6TyxM";
var _16 = "flight_canceled-2POx_";
var _17 = "modal__close-1Ll_m";
var _18 = "flight_select-2lndw";
var _19 = "dropdown__icon-3xYJD";
var _1a = "arrow-Hs-DU";
var _1b = "arrow_opened-1spo8";
var _1c = "fares-1wR6M";
var _1d = "subStatus-2-sOG";
var _1e = "infoMessage-3gNWK";
var _1f = "infoMessage__htmlMessage-24QxU";
export { _1 as "__esModule", _2 as "container", _3 as "flight", _4 as "selected", _5 as "flight_opened", _6 as "flight_dropdown", _7 as "flight_readonly", _8 as "flightContent", _9 as "segments", _a as "segmentItem", _b as "checkinCardItem__container", _c as "transferText", _d as "totalDurationText", _e as "segments_withoutPrices", _f as "segmentSelector_container", _10 as "segmentSelector", _11 as "showSelected", _12 as "segment_segmentSelector", _13 as "segment_segmentSelector_checkbox", _14 as "checked", _15 as "duration", _16 as "flight_canceled", _17 as "modal__close", _18 as "flight_select", _19 as "dropdown__icon", _1a as "arrow", _1b as "arrow_opened", _1c as "fares", _1d as "subStatus", _1e as "infoMessage", _1f as "infoMessage__htmlMessage" }
export default { "__esModule": _1, "container": _2, "flight": _3, "selected": _4, "flight_opened": _5, "flight_dropdown": _6, "flight_readonly": _7, "flightContent": _8, "segments": _9, "segmentItem": _a, "checkinCardItem__container": _b, "transferText": _c, "totalDurationText": _d, "segments_withoutPrices": _e, "segmentSelector_container": _f, "segmentSelector": _10, "showSelected": _11, "segment_segmentSelector": _12, "segment_segmentSelector_checkbox": _13, "checked": _14, "duration": _15, "flight_canceled": _16, "modal__close": _17, "flight_select": _18, "dropdown__icon": _19, "arrow": _1a, "arrow_opened": _1b, "fares": _1c, "subStatus": _1d, "infoMessage": _1e, "infoMessage__htmlMessage": _1f }
